import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Mobile-first layout for the technician app.
 * Dark theme for outdoor visibility, bottom navigation, large touch targets.
 */

const BOTTOM_NAV = [
  { path: '/tech/tasks', label: 'Tasks', icon: '\u2261' },
  { path: '/tech/safety', label: 'Safety', icon: '\u26A0' },
  { path: '/tech/profile', label: 'Profile', icon: '\u2299' },
];

export default function TechnicianLayout({ children, isRTL, t }) {
  const location = useLocation();

  return (
    <div style={{ ...styles.container, direction: isRTL ? 'rtl' : 'ltr' }}>
      {/* Header bar */}
      <header style={styles.header}>
        <span style={styles.headerLogo}>AirTouch</span>
        <span style={styles.headerSub}>Tech</span>
      </header>

      {/* Main content area */}
      <main style={styles.main}>
        {children}
      </main>

      {/* Bottom navigation */}
      <nav style={styles.bottomNav}>
        {BOTTOM_NAV.map(item => {
          const active = location.pathname.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                ...styles.navBtn,
                ...(active ? styles.navBtnActive : {}),
              }}
            >
              <span style={styles.navIcon}>{item.icon}</span>
              <span style={styles.navLabel}>
                {t?.[item.label.toLowerCase()] || item.label}
              </span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: '#0d1117',
    color: '#e6edf3',
    fontFamily: "'Inter', -apple-system, sans-serif",
    maxWidth: 480,
    margin: '0 auto',
    position: 'relative',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '12px 16px',
    background: '#161b22',
    borderBottom: '1px solid #30363d',
    flexShrink: 0,
  },
  headerLogo: {
    fontSize: 18,
    fontWeight: 700,
    color: '#6c5ce7',
  },
  headerSub: {
    fontSize: 12,
    color: '#8b949e',
    fontWeight: 500,
  },
  main: {
    flex: 1,
    overflow: 'auto',
    padding: '16px',
    paddingBottom: 80,
  },
  bottomNav: {
    position: 'fixed',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: 480,
    display: 'flex',
    justifyContent: 'space-around',
    background: '#161b22',
    borderTop: '1px solid #30363d',
    padding: '8px 0',
    zIndex: 100,
  },
  navBtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
    padding: '8px 16px',
    color: '#8b949e',
    textDecoration: 'none',
    fontSize: 11,
    minWidth: 64,
    borderRadius: 8,
  },
  navBtnActive: {
    color: '#6c5ce7',
  },
  navIcon: {
    fontSize: 22,
  },
  navLabel: {
    fontSize: 11,
    fontWeight: 500,
  },
};
